<template>
  <div class="employee container-fluid">
    <employee-filter @getEmployeesList="getEmployeesList"
                     @changeRest="changeRest"
                     @addNew="addNewEmployee">
    </employee-filter>
    <employee-list :employee-list="employeeList"
                   :employee-filter="employeeFilter"
                   @employeeEdit="employeeEdit"
                   @employeeView="employeeView">
    </employee-list>
    <employee-edit v-if="showEditEmployee"
                   ref="editEmployee"
                   :editable-employee="editableEmployee"
                   :employee-filter="employeeFilter"
                   @employeeSaved="employeeSaved"
                   @cancelViewEdit="cancelViewEdit">
    </employee-edit>
    <employee-view v-if="showViewEmployee"
                   ref="viewEmployee"
                   :viewed-employee="viewedEmployee"
                   :employee-filter="employeeFilter"
                   @onEdit="employeeEdit"
                   @cancelViewEdit="cancelViewEdit">
    </employee-view>
  </div>
</template>

<script>
  import EmployeeList from '@/views/WebEditor/Employees/Employees-List';
  import EmployeeEdit from '@/views/WebEditor/Employees/Employees-Edit';
  import EmployeeView from '@/views/WebEditor/Employees/Employees-View';
  import EmployeeFilter from '@/views/WebEditor/Employees/Employees-Filter';
  import { ApiEditor } from '@/services/api';

  export default {
    name: 'Employee',
    components: {
      EmployeeList,
      EmployeeEdit,
      EmployeeView,
      EmployeeFilter
    },

    data() {
      return {
        employeeList: [],
        showEditEmployee: false,
        showViewEmployee: false,
        editableEmployee: null,
        viewedEmployee: null,
        employeeFilter: null
      };
    },

    async created() {
      this.$store.commit('setPageTitle', '#TR-employees');
    },

    methods: {

      changeRest() {
        this.employeeList = [];
      },

      async getEmployeesList(filter) {
        const result = await ApiEditor.geEmployeesList(filter.selectedRole.sifr);
        this.employeeFilter = filter;
        this.employeeList = result.data;
      },

      employeeEdit(employee) {
        this.showViewEmployee = false;
        this.viewedEmployee = null;
        this.showEditEmployee = true;
        this.editableEmployee = employee;
        this.$nextTick(() => {
          this.$refs.editEmployee.openEmployeeEdit();
        });
      },

      employeeView(employee) {
        this.showEditEmployee = false;
        this.editableEmployee = null;
        this.showViewEmployee = true;
        this.viewedEmployee = employee;
        this.$nextTick(() => {
          this.$refs.viewEmployee.openEmployeeView();
        });
      },

      cancelViewEdit() {
        this.showViewEmployee = false;
        this.showEditEmployee = false;
        this.editableEmployee = null;
        this.viewedEmployee = null;
      },

      employeeSaved() {
        this.getEmployeesList(this.employeeFilter);
        this.cancelViewEdit();
      },

      addNewEmployee() {
        this.employeeEdit({});
      }



    }
  };
</script>

<style lang="stylus" scoped>

</style>
